import { useState } from "react";
import { api } from "../api";

interface Props {
  needsBootstrap: boolean;
  onAuthed: () => void;
}

export default function LoginPage({ needsBootstrap, onAuthed }: Props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      if (needsBootstrap) await api.bootstrap(username, password);
      else await api.login(username, password);
      onAuthed();
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <h1>{needsBootstrap ? "First-run setup" : "Sign in"}</h1>
        <p className="muted">
          {needsBootstrap
            ? "No users exist yet. Create the first admin account."
            : "pg-backup-dashboard"}
        </p>

        {err && <div className="error-box" style={{ marginBottom: 12 }}>{err}</div>}

        <label>Username</label>
        <input
          autoFocus required
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
        />

        <label style={{ marginTop: 12 }}>
          Password {needsBootstrap && <span className="muted">(min 8 chars)</span>}
        </label>
        <input
          type="password" required
          minLength={needsBootstrap ? 8 : 1}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete={needsBootstrap ? "new-password" : "current-password"}
        />

        <button className="primary" type="submit" disabled={busy}>
          {busy ? "Working…" : needsBootstrap ? "Create admin & sign in" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
